/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CdmDeviceUiDeviceFragment = { __typename: 'Device', id: string, description: { features: { authentication: { supported: boolean }, proxyDevice: { supported: boolean } } }, features: { authentication: { __typename: 'DeviceAuthenticationState', credentials: Array<{ __typename: 'DeviceAuthenticationCredential', credentialsState: Types.CredentialsState }> | null } | null, proxyDevice: { __typename: 'DeviceProxyDevice', device: { __typename: 'Device', id: string } | null } | null } };

export type CdmDeviceUiDeviceQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['ID']['input'];
}>;


export type CdmDeviceUiDeviceQueryOpResult = { node: CdmDeviceUiDeviceFragment | {} };

export type CdmDeviceUiDiscoveredDevicesSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type CdmDeviceUiDiscoveredDevicesSubscriptionOpResult = { discoveredDevices: { added: { id: string, isDevice: 'Device' } } | { removed: string } };

export const CdmDeviceUiDeviceFragment = gql`
    fragment CdmDeviceUiDeviceFragment on Device {
  __typename
  id
  description {
    features {
      authentication {
        supported
      }
      proxyDevice {
        supported
      }
    }
  }
  features {
    authentication {
      __typename
      credentials {
        __typename
        credentialsState
      }
    }
    proxyDevice {
      __typename
      device {
        __typename
        id
      }
    }
  }
}
    `;
export const CdmDeviceUiDeviceQueryDocument = gql`
    query CdmDeviceUiDeviceQuery($deviceId: ID!) {
  node(id: $deviceId) {
    ...CdmDeviceUiDeviceFragment
  }
}
    ${CdmDeviceUiDeviceFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CdmDeviceUiDeviceQueryGQL extends Apollo.Query<CdmDeviceUiDeviceQueryOpResult, CdmDeviceUiDeviceQueryVariables> {
    override document = CdmDeviceUiDeviceQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CdmDeviceUiDiscoveredDevicesSubscriptionDocument = gql`
    subscription CdmDeviceUiDiscoveredDevicesSubscription {
  discoveredDevices {
    ... on DeviceAdded {
      added {
        isDevice: __typename
        id
      }
    }
    ... on DeviceRemoved {
      removed
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CdmDeviceUiDiscoveredDevicesSubscriptionGQL extends Apollo.Subscription<CdmDeviceUiDiscoveredDevicesSubscriptionOpResult, CdmDeviceUiDiscoveredDevicesSubscriptionVariables> {
    override document = CdmDeviceUiDiscoveredDevicesSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }